import { forwardRef } from 'react'
import { Label } from '@edvi-tech/ui/components/ui/label'
import { cn } from '@edvi-tech/ui/lib/utils'
import { withRequiredMark } from './requiredMark'

/**
 * Compatibility Input — same Controls.Input props.
 * Native <input> + plain CSS borders (avoids ui border-input → black / border-0 wipe).
 */
const Input = forwardRef(function Input(props, ref) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    type = 'text',
    className,
    InputProps,
    inputProps,
    helperText,
    fullWidth: _fullWidth,
    variant: _variant,
    sx: _sx,
    style,
    id,
    ...other
  } = props

  const startAdornment = InputProps?.startAdornment
  const endAdornment = InputProps?.endAdornment
  const hasAdornment = Boolean(startAdornment || endAdornment)
  const message = typeof error === 'string' && error ? error : helperText
  const inputId = id || name
  const invalid = Boolean(error)

  return (
    <div className={cn('edvi-control-field w-full', className)}>
      {label ? (
        <Label
          htmlFor={inputId}
          className="mb-1.5 block text-[13px] font-medium text-[#1c2434]"
        >
          {withRequiredMark(label)}
        </Label>
      ) : null}
      <div className={cn('relative', hasAdornment && 'edvi-control-input-wrap')}>
        {startAdornment ? (
          <span className="edvi-control-adornment edvi-control-adornment--start">
            {startAdornment}
          </span>
        ) : null}
        <input
          ref={ref}
          id={inputId}
          name={name}
          type={type}
          value={value ?? ''}
          onChange={onChange}
          aria-invalid={invalid}
          {...other}
          {...inputProps}
          className={cn('edvi-control-input', inputProps?.className)}
          style={{
            ...inputProps?.style,
            ...style,
            ...(startAdornment
              ? { paddingInlineStart: '2.5rem', paddingLeft: '2.5rem' }
              : null),
            ...(endAdornment
              ? { paddingInlineEnd: '2.5rem', paddingRight: '2.5rem' }
              : null),
          }}
        />
        {endAdornment ? (
          <span className="edvi-control-adornment edvi-control-adornment--end">
            {endAdornment}
          </span>
        ) : null}
      </div>
      {message ? (
        <p
          className={cn(
            'edvi-control-field__msg',
            error ? 'edvi-control-field__msg--error' : null,
          )}
        >
          {message}
        </p>
      ) : null}
    </div>
  )
})

export default Input
